import { PlusOutlined } from "@ant-design/icons";
import { Button, Modal as AntModal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import axiosInstance from "../../../variables/api/axiosInstance";
import AddTypeEtablissement from "./AddTypeEtablissement";
import ActionDropdown from "../../production/components/ActionDropdown";

const TypeEtablissements = () => {
  const [types, setTypes] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedType, setSelectedType] = useState(null);

  const fetchTypes = () => {
    axiosInstance
      .get(`/api/parametre/type/TYPE_ETABLISSEMENT`)
      .then((res) => {
        const sorted = (res.data || []).sort((a, b) => b.parametreId - a.parametreId);
        setTypes(sorted);
      })
      .catch((err) => {
        console.error("Erreur lors du chargement des types d'établissement :", err);
        toast.error("Erreur lors du chargement des types d'établissement");
      });
  };

  useEffect(() => {
    fetchTypes();
  }, []);

  const handleShow = (edit = false, type = null) => {
    setEditMode(edit);
    setSelectedType(type);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedType(null);
  };

  const handleActionComplete = (saved) => {
    if (saved?.parametreId) {
      setTypes((prev) => {
        const exists = prev.some((t) => t.parametreId === saved.parametreId);
        if (exists) {
          return prev
            .map((t) => (t.parametreId === saved.parametreId ? saved : t))
            .sort((a, b) => b.parametreId - a.parametreId);
        }
        return [saved, ...prev].sort((a, b) => b.parametreId - a.parametreId);
      });
    } else {
      fetchTypes();
    }
  };

  const handleDelete = (parametreId) => {
    AntModal.confirm({
      title: "Supprimer ce type d'établissement ?",
      content: "Cette action est irréversible.",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axiosInstance
          .delete(`/api/parametre/${parametreId}`)
          .then(() => {
            setTypes((prev) => prev.filter((t) => t.parametreId !== parametreId));
            toast.success("Type d'établissement supprimé avec succès.");
          })
          .catch((err) => {
            console.error("Erreur lors de la suppression :", err);
            toast.error("Impossible de supprimer ce type d'établissement.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Libellé",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => handleDelete(record.parametreId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="PARAMETRES_SINISTRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow(false, null)}
              >
                Ajouter un type d'établissement
              </Button>
              <div className="card">
                <h5 className="card-header">Types d'établissement</h5>
                <Table
                  columns={columns}
                  dataSource={types}
                  rowKey="parametreId"
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      <AddTypeEtablissement
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedType={selectedType}
        types={types}
        onActionComplete={handleActionComplete}
      />
    </div>
  );
};

export default TypeEtablissements;
